import API from '../Api'
import http from '../http'

/**
 * 获取注册信息
 * @returns {*}
 */
function getRegisterInfo () {
  return http.get(API.registerInfo, {
    params: {}
  })
}

export default {
  getRegisterInfo
}



// WEBPACK FOOTER //
// ./src/service/report/index.js